import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';

const styles = theme => ({
  container: {
    width: '95%'
  },
  root: {
    width: '95%',
    minHeight: '500px',
    //marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
    margin: '0 Auto',
    //display: 'flex',
    //justifyContent: 'center',
  },
  table: {
    tableLayout: 'auto',
    minWidth: 300,
  },
  header: {
    backgroundColor: 'primary',
  },
  leftCell: {
    borderRight: '0.1em solid rgba(224, 224, 224, 1)',
  },
});

class AboutOnlineArbitration extends Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <Typography variant="h5" align='justify' gutterBottom>
          {this.context.t('description1')}
        </Typography>
        <Typography variant="h5" align='justify' gutterBottom>
          {this.context.t('description2')}
        </Typography>
        <Typography variant="h5" align='justify' gutterBottom>
          {this.context.t('description3')}
        </Typography>
        <Typography variant="h5" align='justify' gutterBottom>
          {this.context.t('description4')}
        </Typography>
        <Typography variant="h5" align='justify' gutterBottom>
          {this.context.t('description5')}
        </Typography>
        <Typography variant="h5" align='justify' gutterBottom>
          {this.context.t('description6')}
        </Typography>
        <Typography variant="h5" align='justify' gutterBottom>
          {this.context.t('description7')}
        </Typography>
        <Typography variant="h5" align='justify' gutterBottom>
          {this.context.t('description8')}
        </Typography>
        <Typography variant="h5" align='justify' gutterBottom>
          {this.context.t('description9')}
        </Typography>
        <Typography variant="h5" align='justify' gutterBottom>
          {this.context.t('description10')}
        </Typography>
        <Typography variant="h5" align='justify' gutterBottom>
          {this.context.t('description11')}
        </Typography>
        <Typography variant="h5" align='justify' gutterBottom>
          {this.context.t('description12')}
        </Typography>
      </div>
    );
  }

}

AboutOnlineArbitration.contextTypes = {
  t: PropTypes.func
}

export default withStyles(styles)(AboutOnlineArbitration);